import { TaskItem } from '../api';

export interface TreeNode {
  task: TaskItem;
  children: TreeNode[];
}

export function buildTree(tasks: TaskItem[]): TreeNode[] {
  const map = new Map<string, TreeNode>();
  for (const t of tasks) map.set(t.id, { task: t, children: [] });

  const roots: TreeNode[] = [];
  for (const node of map.values()) {
    const parentId = node.task.parentId;
    if (parentId && map.has(parentId) && parentId !== node.task.id) {
      map.get(parentId)!.children.push(node);
    } else {
      roots.push(node);
    }
  }
  return roots;
}

export interface FlatTask {
  task: TaskItem;
  depth: number;
}

// Depth-first, parents before children, siblings sorted oldest-first.
export function flattenTree(tasks: TaskItem[]): FlatTask[] {
  const roots = buildTree(tasks);
  const out: FlatTask[] = [];
  const visit = (nodes: TreeNode[], depth: number) => {
    nodes.sort(
      (a, b) =>
        new Date(a.task.createdAt).getTime() - new Date(b.task.createdAt).getTime()
    );
    for (const n of nodes) {
      out.push({ task: n.task, depth });
      visit(n.children, depth + 1);
    }
  };
  visit(roots, 0);
  return out;
}

export function descendants(tasks: TaskItem[], taskId: string): Set<string> {
  const result = new Set<string>();
  const children = tasks.filter((t) => t.parentId === taskId);
  for (const child of children) {
    result.add(child.id);
    for (const d of descendants(tasks, child.id)) result.add(d);
  }
  return result;
}

export function epicName(epics: { id: string; name: string }[], epicId: string | null): string {
  if (!epicId) return '';
  return epics.find((e) => e.id === epicId)?.name || '';
}
